module.exports = __webpack_public_path__ + "img/marker_PIT.4ede1572.svg";